import React from 'react';

import { defineMessages, FormattedMessage, useIntl } from 'react-intl-next';

import EmptyState from '@atlaskit/empty-state';
import {
	getAtlassianContextDomain,
	getAtlassianContextUrl,
} from '@atlassian/teams-common/context-config';

import WorkListErrorImage from '../../assets/empty-work-state/WorkListError_ptc.svg';
import SearchMoreWork from '../SearchMoreWork';

interface Props {
	userId?: string;
	userFullName?: string;
}

const SUPPORT_LINK_URI = getAtlassianContextUrl('support');
const SUPPORT_LINK = getAtlassianContextDomain('support');

function ErrorWorkState(props: Props) {
	const { userId, userFullName } = props;
	const intl = useIntl();

	return (
		<EmptyState
			header={intl.formatMessage(messages.errorTitle)}
			description={
				<FormattedMessage
					{...messages.errorDesc}
					values={{
						a: () => (
							<a
								data-testid="support-link"
								href={SUPPORT_LINK_URI}
								target="_blank"
								rel="noopener noreferrer"
							>
								{SUPPORT_LINK}
							</a>
						),
					}}
				/>
			}
			imageUrl={WorkListErrorImage}
			primaryAction={
				userFullName &&
				userId && <SearchMoreWork isInEmptyState userId={userId} userFullName={userFullName} />
			}
		/>
	);
}

const messages = defineMessages({
	errorTitle: {
		id: 'ptc-directory.profile-page.table-work-list.error.title',
		defaultMessage: 'We seem to have lost the connection',
		description: 'Title of error UI when fetching work list fails',
	},

	errorDesc: {
		id: 'ptc-directory.profile-page.table-work-list.error.desc',
		defaultMessage:
			'Wait a few moments, then try refreshing the page. If this keeps happening, let us know at <a></a>.',
		description: 'Description of error UI when fetching work list fails',
	},
});

export default ErrorWorkState;
